import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { Share } from '@ifeng/ui_pc_share';
import errorBoundary from '@ifeng/errorBoundary';

class ShareIconBox extends React.PureComponent {
    // share组件存在两个问题：hover 微信的图标二维码；hover 分享图标变红；顶部横线；图片圆框；
    state = {
        isShow: false,
    };

    handleClick = () => {
        const { isShow } = this.state;

        this.setState({ isShow: !isShow });
    };

    /**
     * 渲染网页布局
     */

    render() {
        const { isShow } = this.state;
        const { docData } = this.props;
        const { title, summery, url, imagesInContent } = docData;

        const config = {
            items: ['sina', 'wechat', 'qqzone'],
            display: 'gray',
            hover: 'hover',
            type: 'vertical',
            methods: 'hover',
            tooltip: 'left',
        };

        const shareInfo = {
            url,
            title,
            summery,
            picUrl: imagesInContent && imagesInContent.url ? imagesInContent.url : '',
        };

        console.log('shareInfo__', shareInfo);

        return (
            <li className={styles.titshare} onClick={this.handleClick}>
                <div className={isShow ? styles.vertical : styles.boxhidden}>
                    <Share config={config} shareInfo={shareInfo} />
                </div>
            </li>
        );
    }
}

/**
 * 定义组件属性类型
 * */
ShareIconBox.propTypes = { docData: PropTypes.object };

/**
 * 定义组件默认属性
 * */
ShareIconBox.defaultProps = {};

export { ShareIconBox };
export default errorBoundary(ShareIconBox);
